import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { AccessKey } from 'src/features/accessKey/utils/types';
import DeleteAccessKey from 'src/features/accessKey/components/form/DeleteAccessKey';
import UpdateAccessKeyFormModal from 'src/features/accessKey/components/form/UpdateAccessKeyFormModal';

export default function CellAccessKeyActions<TData, TValue>({ row }: CellContext<TData, TValue>) {
    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateAccessKeyFormModal selectedAccessKey={row.original as AccessKey}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateAccessKeyFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteAccessKey selectedAccessKey={row.original as AccessKey}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteAccessKey>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
